import React from 'react';
import BinIcon from '../../images/bin_icon.png'
import PlusIcon from '../../images/+_icon.png'
import ResetTOTPIcon from '../../images/2FA_Reset_Icon.png'
import { withTranslation } from 'react-i18next';
import Dialog from '../Dialog/Dialog';
import { AdminHandler } from '../AdminHandler/AdminHandler';
import SearchBar from '../SearchBar/SearchBar';
import Checkmark from '../../images/faq_check.png'
import Pagination from '../Pagination/Pagination';
import { callIfMouseSupported, callIfTouchSupported, callIfPointerSupported } from '../General/EventSupport';

const MAX_USERS_PER_PAGE = 12;

class UserList extends React.Component {

    getUsersSortTags() {
        const { t } = this.props;
        return [
            {title: t('SortTagName'),
                function:
                function(elements){
                    elements.sort(function(a, b){
                    if(a.UserName < b.UserName) { return -1; }
                    if(a.UserName > b.UserName) { return 1; }
                    return 0;
                })
                }},
            {title: t('SortTagUsersCompanyName'),
                function:
                (elements) => {
                    elements.sort(function(a, b){
                    const companyNameA = this.getCompanyName(a.Company);
                    const companyNameB = this.getCompanyName(b.Company);
                    if(companyNameA < companyNameB) { return -1; }
                    if(companyNameA > companyNameB) { return 1; }
                    return 0;
                }.bind(this))
                }},
            {title: t('SortTagUsersRole'),
                function:
                (elements) => {
                    elements.sort(function(a, b){
                    return a.UserRole - b.UserRole;
                })
                }},
        ];
    }

    static defaultProps = {
      realm: null,
      companyID: null,
      companies:[],
      userID: "",
    };

    constructor(props) {
        super(props);

        this.state = {
          users: [],
          companies: [],
          addingUser: false,
          addingCompany: false,
          tempCompanyName: "",
          tempCompanyLimit: 0,
          tempUserEmail: "",
          tempUserName: "",
          tempUserCompany: "",
          tempUserlocale: "de",
          tempUserRole: "1",
          usersSearchOptions: {sortTag: this.getUsersSortTags()[0], filterTag: null, inverted: false},
          open: true,
          headerOpen: true,
          searchedUsers: [],
          usersToRender: [],

          //pagination
          maxUsersPerPage: MAX_USERS_PER_PAGE,
          userPageIndex: 0,
          userPagesAmount: 0,
        };
    }

    componentDidMount(){
      this.getUsers(this.props.companies);
    }

    componentDidUpdate(prevProps){
      if (prevProps.companies !== this.props.companies) {
        this.getUsers(this.props.companies);
      }
    }

    getCompanyName(companyGuid){
      var company = this.props.companies.filter(company => company.CompanyGuid === companyGuid)[0]
      var companyName = "";
      if (company != null){
        companyName = this.props.companies.filter(company => company.CompanyGuid === companyGuid)[0].CompanyName;
      }

      return companyName;
    }

    getUsers(newCompanies){ //TODO
        const self = this;
        AdminHandler.getAllUsers("asd")
        .then((res) => {
            if (newCompanies){
                res.data.sort((a,b) => {
                    if (a == null || b == null) return 0;

                    var companyNameA = newCompanies.filter(company => company.CompanyGuid === a.Company)[0]?.CompanyName;
                    var companyNameB = newCompanies.filter(company => company.CompanyGuid === b.Company)[0]?.CompanyName;

                    if (companyNameA === companyNameB){
                        return a.UserName > b.UserName ? 1 : -1;
                    }else{
                        return companyNameA > companyNameB ? 1 : -1;
                    }
                });
            }

            this.setUsersToRender(res.data, this.state.usersSearchOptions, 0);
            self.setState({
                users: res.data,
            });
        })
        .catch((err) => {
            console.error(err);
        })
    }

    generateUserLink(id){
        if(id){
            if (window.config.host.cdn.includes("vithrough"))
            return "https://viewer.vithrough.com/?userID=" + id;
            else
            return window.config.host.cdn + "/" + this.props.realm + "/modelviewer/?userID=" + id;
        }else{
            return null
        }
    }

    updateUserRole(newVal, userMail)
    {
        var newUsers = this.state.users;
        var user = newUsers.find((e) => e.UserEmail === userMail);
        var prevRole = user.UserRole;
        user.UserRole = newVal;
        this.setState({users: newUsers});
        AdminHandler.updateUserRole(newVal, userMail)
        .then((res) => {})
        .catch((err) =>{
            console.error(err);
            user.UserRole = prevRole;
            this.setState({users: newUsers});
        })
    }

    getSearchedUsers(users, searchOptions){
        if(!users){
            return [];
        }

        if(!searchOptions){
            return users;
        }

        let usersToRender = users;
        if(searchOptions){
            if(searchOptions.sortTag){
                // --> sort companies
                searchOptions.sortTag.function(usersToRender);
                if(searchOptions.inverted){
                    usersToRender.reverse();
                }
            }

            if(searchOptions.filterTag){
                // --> filter companies
                usersToRender = searchOptions.filterTag.function(usersToRender, searchOptions.filterTag.searchText);
            }
        }

        return usersToRender;
    }

    getUserTable(usersToRender){
        const { t } = this.props;
        if(!usersToRender){
            return;
        }

        var elements = [];
        usersToRender.map((elem, indx) => {
            var company = this.props.companies.filter(company => company.CompanyGuid === elem.Company)[0]
            var companyName = "";
            var companyTfaEnabled = elem.CompanyTfaPolicy === 1 || elem.CompanyTfaPolicy === true;
            if (company != null){
                companyName = this.props.companies.filter(company => company.CompanyGuid === elem.Company)[0].CompanyName;
                elements.push(
                    <tr className='TableRow' key={indx}>
                        <td title={elem.UserName}>{elem.UserName}</td>
                        <td title={elem.UserEmail}>{elem.UserEmail}</td>
                        <td title={companyName}>{companyName}</td>
                        <td title={elem.UserLocale}>{elem.UserLocale}</td>
                        <td>
                            <select value={elem.UserRole} onChange={(e) => this.updateUserRole(e.target.value, elem.UserEmail)} title='UserRole'>
                            <option value="1">Admin</option>
                            <option value="2">Editor</option>
                            <option value="3">User</option>
                            </select>
                        </td>
                        <td>
                            <div className='table_buttons_container'>
                                <button
                                    className="armodelviewer_button"
                                    title={t('ResetTOTP')}
                                    disabled={!companyTfaEnabled}
                                    onClick={() => this.resetTOTP(elem.UserEmail)}>
                                        <img alt={t('ResetTOTP')} src={ResetTOTPIcon}/>
                                </button>
                                <button
                                    className="armodelviewer_button"
                                    title={t('RemUser')}
                                    onClick={() => this.remUser(elem.UserGuid)}>
                                        <img alt={t('Delete')} src={BinIcon}/>
                                </button>
                            </div>
                        </td>
                    </tr>
                )
            }
            else
            {
                elements.push(
                    <tr className='TableRow' key={indx}>
                        <td title={elem.UserName}>{elem.UserName}</td>
                        <td title={elem.UserEmail}>{elem.UserEmail}</td>
                        <td>{""}</td>
                        <td title={elem.UserLocale}>{elem.UserLocale}</td>
                        <td>
                            <select value={elem.UserRole} onChange={(e) => this.updateUserRole(e.target.value, elem.UserEmail)} title='UserRole'>
                            <option value="1">Admin</option>
                            <option value="2">Editor</option>
                            <option value="3">User</option>
                            </select>
                        </td>
                        <td>
                            <div className='table_buttons_container'>
                                <button
                                    className="armodelviewer_button"
                                    title={t('ResetTOTP')}
                                    disabled={!companyTfaEnabled}
                                    onClick={() => this.resetTOTP(elem.UserEmail)}>
                                        <img alt={t('ResetTOTP')} src={ResetTOTPIcon}/>
                                </button>
                                <button
                                    className="armodelviewer_button"
                                    title={t('RemUser')}
                                    onClick={() => this.remUser(elem.UserGuid)}>
                                        <img alt={t('Delete')} src={BinIcon}/>
                                </button>
                            </div>
                        </td>
                    </tr>
                )
            }
            return "";
        });

        return elements;
    }

    getCompanyOptions(){
        var elements = [];
        this.props.companies.map((elem, indx) =>
            (
            elements.push(
                <option>{elem.CompanyName}</option>)
            ));
        return elements;
    }

    checkCanAddUser(companyId)
    {
        var openSlots = 0;
        this.props.companies.forEach(company => {
            if (company.CompanyGuid === companyId)
            {
                openSlots = company.UserLimit;
            }
        });

        this.state.users.forEach(
            (user) =>
            {
                if (user.Company === companyId)
                {
                    openSlots--;
                }
            }
        )
        return openSlots > 0;
    }

    addUserDialog()
    {
        const { t } = this.props;
        var companies = [];
        var roles = ["Admin", "Editor", "Nutzer"]
        if (companies !=null)
        this.props.companies.map((v,k) => {
            companies.push(v.CompanyName)
            return "";
        })

        const self = this;
        Dialog.Alert({
            title: "Neuen Nutzer anlegen",
            description: "Das Passwort Feld ausfüllen, um Nutzer nicht automatisch zu benachrichtigen und das Passwort direkt zu setzen",
            options: [
                {label: "OK", className:"dangerConfirm"},
                {label: "Abbrechen", className:""},
            ],
            inputs: [
                {type: "text", name: "Name"},
                {type: "text", name: "E-Mail"},
                {type: "text", name: "Passwort"},
                {type: "select", name: "Sprache", options: ["de", "en"]},
                {type: "select", name: "Rolle", options: roles},
                {type: "select", name: "Unternehmen", options: companies},
            ],
            panelOptions: {className: "vithrough"}
        })
        .then((res) => {
            if (res["Option"] === 1) return;
            var companyId = this.getCompanyIdFromName(companies[res["Unternehmen"]]);
            if (this.checkCanAddUser(companyId))
                {
                    if (res["Passwort"] !== "")
                    {
                        AdminHandler.addUserWithPassword(res["Name"], res["E-Mail"], res["Sprache"] === 0 ? "de" : "en", res["Rolle"] + 1, companyId, companies[res["Unternehmen"]], res["Passwort"])
                        .then((res) => {
                            self.resetInputFields();
                            self.getUsers(this.props.companies);
                        })
                        .catch((err) =>{
                        if(err.Success == false)
                        {
                            if(err.Code == 400){
                                Dialog.Alert({
                                    title: t('NewUserCreateErrorTitle'),
                                    description: t('NewUserInvalidDataError'),
                                    options: [
                                        {label: "OK", className:""},
                                    ],
                                    panelOptions: {className: "vithrough oneButtonDialog"}
                                })
                            }else if(err.Code == 409){
                                Dialog.Alert({
                                    title: t('NewUserCreateErrorTitle'),
                                    description: t('NewUserConflictError'),
                                    options: [
                                        {label: "OK", className:""},
                                    ],
                                    panelOptions: {className: "vithrough oneButtonDialog"}
                                })
                            }else if(err.Code >= 500 && err.Code < 600){
                                Dialog.Alert({
                                    title: t('NewUserCreateErrorTitle'),
                                    description: t('NewUserCreateError'),
                                    options: [
                                        {label: "OK", className:""},
                                    ],
                                    panelOptions: {className: "vithrough oneButtonDialog"}
                                })
                            }
                            else{                                
                                Dialog.Alert({
                                    title: t('NewUserCreateErrorTitle'),
                                    description: t('NewUserCreateError'),
                                    options: [
                                        {label: "OK", className:""},
                                    ],
                                    panelOptions: {className: "vithrough oneButtonDialog"}
                                })
                            }
                        }})
                    }else{
                        AdminHandler.addUser(res["Name"], res["E-Mail"], res["Sprache"] === 0 ? "de" : "en", res["Rolle"] + 1, companyId, companies[res["Unternehmen"]], this.props.userID)
                    .then((res) => {
                        self.resetInputFields();
                        self.getUsers(this.props.companies);
                    })
                    .catch((err) =>{
                        if(err.Success == false)
                        {
                            if(err.Code == 400){
                                Dialog.Alert({
                                    title: t('NewUserCreateErrorTitle'),
                                    description: t('NewUserInvalidDataError'),
                                    options: [
                                        {label: "OK", className:""},
                                    ],
                                    panelOptions: {className: "vithrough oneButtonDialog"}
                                })
                            }else if(err.Code == 409){
                                Dialog.Alert({
                                    title: t('NewUserCreateErrorTitle'),
                                    description: t('NewUserConflictError'),
                                    options: [
                                        {label: "OK", className:""},
                                    ],
                                    panelOptions: {className: "vithrough oneButtonDialog"}
                                })
                            }else if(err.Code >= 500 && err.Code < 600){
                                Dialog.Alert({
                                    title: t('NewUserCreateErrorTitle'),
                                    description: t('EMailError'),
                                    options: [
                                        {label: "OK", className:""},
                                    ],
                                    panelOptions: {className: "vithrough oneButtonDialog"}
                                })
                            }else{
                                Dialog.Alert({
                                    title: t('NewUserCreateErrorTitle'),
                                    description: t('NewUserCreateError'),
                                    options: [
                                        {label: "OK", className:""},
                                    ],
                                    panelOptions: {className: "vithrough oneButtonDialog"}
                                })
                            }
                        }})
                    }
                }else{
                    Dialog.Alert({
                        title: t('NewUserCreateErrorTitle'),
                        description: t('NewUserSeatLimitError'),
                        options: [
                            {label: "OK", className:""},
                        ],
                        panelOptions: {className: "vithrough oneButtonDialog"}
                    })
                }
        })
        .catch((err) =>{
            console.error(err);
        })
        return;
    }

    addUser(){
        const self = this;
        var companyId = this.getCompanyIdFromName(this.state.tempUserCompany)

        if (this.checkCanAddUser(companyId))
        {
            AdminHandler.addUser(this.state.tempUserName, this.state.tempUserEmail, this.state.tempUserlocale, this.state.tempUserRole, companyId)
            .then((res) => {
                self.resetInputFields();
                self.getUsers(this.props.companies);
            })
            .catch((err) =>{
                console.error(err);
            })
        }
        else
        {
            Dialog.Alert({
                title: "Fehler beim Anlegen des Nutzers",
                description: "Das Nutzerlimit des Unternehmens erlaubt keinen neuen Benutzer.",
                options: [
                    {label: "OK", className:""},
                ],
                panelOptions: {className: "vithrough oneButtonDialog"}
            })
        }
        return;
    }

    resetInputFields(){
        this.setState({addingUser: false, addingCompany: false, tempCompanyName: "",tempCompanyLimit: 0, tempUserEmail: "", tempUserName: "", tempUserCompany: "",tempUserlocale: "de", tempUserRole: "1"});
    }

    getCompanyIdFromName(companyName){
        var companyid = "";
        this.props.companies.forEach(company => {
            if (company.CompanyName === companyName)
            {
                companyid = company.CompanyGuid;
            }
        });

        return companyid;
    }

    remUser(userguid){
        const { t } = this.props;
        const self = this;
        var useridx = this.getUserIndexByGuid(userguid);
        var username = this.state.users[useridx].UserEmail;
        Dialog.Alert({
                title: t('RemUser') + " " + username,
                description: t('RemUserSure'),
                options: [
                    {label: t('Delete'), className:"dangerConfirm"},
                    {label: t('Cancel'), className:""},
                ],
                panelOptions: {className: "vithrough"}
            }).then((optionChosen) => {
             var userid = userguid;
            if (optionChosen === 0) {
                AdminHandler.remUser(userid)
                .then((res) => {
                    self.setState({addingUser: false});
                    self.getUsers(this.props.companies);
                })
                .catch((err) =>
                {
                    self.getUsers(this.props.companies);
                })
            }
        });
    }

    resetTOTP(email){
        const { t } = this.props;
        Dialog.Alert({
            title: t('ResetTOTP') + " " + email,
            description: t('ResetTOTPSure'),
            options: [
                {label: t('Reset'), className:"dangerConfirm"},
                {label: t('Cancel'), className:""},
            ],
            panelOptions: {className: "vithrough"}
        }).then((optionChosen) => {
            if (optionChosen !== 0) return;
            AdminHandler.ResetTOTP(email, this.props.realm)
            .then(() => {
                Dialog.Alert({
                    title: t('ResetTOTP'),
                    description: t('ResetTOTPSuccess'),
                    options: [
                        {label: t('OK'), className:""},
                    ],
                    panelOptions: {className: "vithrough oneButtonDialog"}
                })
            })
            .catch(() => {
                Dialog.Alert({
                    title: t('ResetTOTP'),
                    description: t('ResetTOTPError'),
                    options: [
                        {label: t('OK'), className:""},
                    ],
                    panelOptions: {className: "vithrough oneButtonDialog"}
                })
            })
        });
    }

    getUserIndexByGuid(userGuid){
        if(!this.state.users || userGuid == null){
            return -1;
        }

        return this.state.users.findIndex(user => user.UserGuid === userGuid);
    }

    getPageAmount(elements){
        if(!elements || elements.length === 0){
            return 0;
        }

        return Math.ceil(elements.length / this.state.maxUsersPerPage);
    }

    setUsersToRender(usersToSearch, searchOptions, pageIndex){
        let searchedUsers = this.getSearchedUsers(usersToSearch, searchOptions);
        let pageAmount = this.getPageAmount(searchedUsers);
        let usersOnPage = searchedUsers.slice(pageIndex * this.state.maxUsersPerPage, (pageIndex + 1) * this.state.maxUsersPerPage);
        this.setState({
            usersSearchOptions: searchOptions,
            searchedUsers: searchedUsers,
            userPageIndex: pageIndex,
            userPagesAmount: pageAmount,
            usersToRender: usersOnPage,
        })
    }

    render() {
        const { t } = this.props;
        const state = this.state;
        const usersSortTags = this.getUsersSortTags();
        const showFooter = state.searchedUsers?.length > state.maxUsersPerPage;
        return (
        <div className='user_files_container'>
            <div className={state.headerOpen ? 'user_files_list_header open' : 'user_files_list_header'}
                onPointerUp={(e) => {
                    callIfPointerSupported(() => this.setState({open: !state.open, headerOpen: !state.open === true ? true : state.headerOpen}), e);
                    e.stopPropagation();
                    e.preventDefault();
                }}
                    onTouchStart={(e) => {
                    callIfTouchSupported(() => this.setState({open: !state.open, headerOpen: !state.open === true ? true : state.headerOpen}));
                    e.stopPropagation();
                    e.preventDefault();
                }}
                    onMouseUp={(e) => {callIfMouseSupported(() => this.setState({open: !state.open, headerOpen: !state.open === true ? true : state.headerOpen}), e);
                    e.stopPropagation();
                    e.preventDefault();
                }}
            >
                <div className='user_files_list_header_left'>
                    <div id='user_list_circle' className='user_list_circle'/>
                    <label id='Models'>{t('Users')}</label>
                </div>
            </div>
            <div
                className={'user_files_list_container' + (state.open ? '_open' : '_hidden') + (showFooter ? '' : ' no_footer')}
                onTransitionEnd={() => {
                    if(!state.open){
                        this.setState({headerOpen: false});
                    }
                }}
            >
                <div className='user_files_list_container_inner'>
                <SearchBar
                    onNewSearchOptions={(options) => {
                        this.setUsersToRender(state.users, options, 0);
                    }}
                    sortTags={usersSortTags}
                    filterTags={[
                        {title: t('FilterTagName'),
                            function:
                            function(elements, filterText){
                                return elements.filter((elem) => {
                                if(filterText == null || filterText === ""){
                                    return true; //if there is nothing to filter against
                                }
                                return elem && elem.UserName && filterText && elem.UserName.toLowerCase().indexOf(filterText.toString().toLowerCase()) >= 0;
                            })
                        }},
                    ]}
                />
                <div className='user_files_list'>
                    <table className='user_table'>
                        <colgroup>
                            <col className='first-col'/>
                            <col className='second-col'/>
                            <col className='third-col'/>
                            <col className='forth-col'/>
                            <col className='fifth-col'/>
                            <col className='sixth-col'/>
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Company</th>
                                <th>{t('Language')}</th>
                                <th>Role</th>
                                <th>
                                {!state.addingUser &&
                                    <button
                                        className="armodelviewer_button admin_buttons"
                                        title={t('AddUser')}
                                        onClick={() => this.addUserDialog()}>
                                            <img alt={t('AddUser')} src={PlusIcon}></img>
                                    </button>
                                }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {state.addingUser &&
                                <tr key="-1">
                                    <td>
                                        <input
                                            type='text'
                                            value={state.tempUserName}
                                            onChange={(e) => this.setState({tempUserName: e.target.value})}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type='text'
                                            value={state.tempUserEmail}
                                            onChange={(e) => this.setState({tempUserEmail: e.target.value})}
                                        />
                                    </td>
                                    <td>
                                        <select
                                            value={state.tempUserCompany}
                                            onChange={(e) => this.setState({tempUserCompany: e.target.value})}
                                        >
                                            <option></option>
                                            {this.getCompanyOptions()}
                                        </select>
                                    </td>
                                    <td>
                                        <select
                                            value={state.tempUserlocale}
                                            onChange={(e) => this.setState({tempUserlocale: e.target.value})}
                                        >
                                            <option>de</option>
                                            <option>en</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select
                                            value={state.tempUserRole}
                                            onChange={(e) => this.setState({tempUserRole: e.target.value})}
                                        >
                                            <option value="1">Admin</option>
                                            <option value="2">Editor</option>
                                            <option value="3">User</option>
                                        </select>
                                    </td>
                                    <td>
                                        <div className='table_buttons_container'>
                                            <button
                                                title={t('AddUser')}
                                                onClick={() => this.addUser()}
                                                className="armodelviewer_button">
                                                    <img alt={t('AddUser')} src={Checkmark}/>
                                            </button>
                                            <button
                                                title={t('Cancel')}
                                                onClick={() => this.resetInputFields()}
                                                className="armodelviewer_button">
                                                    <img alt={t('Cancel')} className='img_rotate_45' src={PlusIcon}/>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            }
                            {this.getUserTable(state.usersToRender)}
                        </tbody>
                    </table>
                </div>
                {showFooter &&
                    <div className='user_files_list_footer'>
                        <span className='border_span'/>
                        <Pagination
                            pageIndex={state.userPageIndex}
                            pageAmount={state.userPagesAmount}
                            onClickPageLink={(pageIndex) =>{
                                this.setUsersToRender(state.users, state.usersSearchOptions, pageIndex)
                            }}
                        />
                    </div>
                }
                </div>
            </div>
        </div>);
    }
}

export default withTranslation()(UserList);
